<template>
  <div id="app">
    <div class="header">
      <!--<div class="pay fa fa-dollar" @click="onClickShowPay">觉得好用？欢迎给我打赏</div>-->
      <PayMoney></PayMoney>
      <h1>电影字幕拼接工具</h1>
    </div>
    <router-view/>
  </div>
</template>

<script>
  import PayMoney from './components/pay.vue'
export default {

  name: 'app',
  components: {
    PayMoney
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style>
  * { margin:0; padding:0; user-select: none; -webkit-user-select: none; -moz-user-select: none; }
  html, body { height:100%; position: relative; font-family: Helvetica, 'Pingfang SC', 'microsoft yahei'; background: #fafafa;}
  .header { height:70px; position: absolute; line-height: 70px; text-align: left; top:0; width:100%; left:0; background: #009E8E; color:#ffffff; box-shadow: 0 0px 10px #009E8E; }
  h1 { font-size:18px; padding-left:10px;}
  #app { height:100%; width:100%; position: relative; overflow: hidden;}
  .wrap { position: absolute; left:0; right:0; bottom:0; top:70px; }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/App.vue